module.exports = __webpack_public_path__ + "img/unit1-architectural.f27b64ca.svg";